import { feature as accountActionsHandler } from '@central-products/account-actions-handler';
import { feature as loginFlow } from '@central-products/login-flow';
import { feature as registrationFlow } from '@central-products/registration-flow';
import { feature as graphqlClient } from '@central-products/graphql-client';
import { feature as casSessionManager } from '@central-products/cas-session-manager';
import { feature as accountActions } from '@central-products/account-actions';
import { feature as authenticationErrors } from '@central-products/authentication-errors';
import { feature as webLoginPreferences } from '@central-products/web-login-preferences';
import { feature as sessionService } from '@central-products/session-service';
import { feature as flagsHandler } from '@central-products/flags-handler';
import { feature as myaccountService } from '@myaccount/myaccount';
import { feature as saferGamblingModals } from '@myaccount/safer-gambling-modals';
import { feature as obSessionService } from '@central-products/obsession-service';
import { feature as promotionsFlow } from '@central-products/promotions-flow';
import { feature as hiddenMarketsWidgetFlow } from '@central-products/hidden-markets-widget-flow';

/**
 * DCFFlowFeature is needed by AccountActionsHandler
 * but until feature is enabled we need to mock it.
 */
const DCFFlowFeatureMock = {
  name: '@feature/dcf-flow',
  create: () => ({ start: () => null }),
  dependsOn: [],
  role: 'decouple-card-flow',
  implements: 'DecoupleCardFlowInterface',
  bindToTransport: false,
};

const availableBootstrapFeatures = {
  accountActions,
  accountActionsHandler,
  authenticationErrors,
  casSessionManager,
  flagsHandler,
  graphqlClient,
  loginFlow,
  myaccountService,
  obSessionService,
  registrationFlow,
  sessionService,
  webLoginPreferences,
  DCFFlowFeatureMock,
  promotionsFlow,
  saferGamblingModals,
  hiddenMarketsWidgetFlow,
};

const getBootstrapFeatures = (requiredBootstrapFeatures) =>
  Object.keys(requiredBootstrapFeatures)
    .filter((bootstrapFeature) => requiredBootstrapFeatures[bootstrapFeature] === true)
    .map((bootstrapFeature) => availableBootstrapFeatures[bootstrapFeature]);

export default getBootstrapFeatures;
